import Pet from "./Pet";

export default class PetOwl extends Pet {
    constructor() {
        super("guardian_pet", Pet.TYPE_OWL);
    }

    init() {
        super.init(P3.utils.selectRandom(["pet1"]));
    }
}